import { click } from './click'
import { select } from './select'
import { draw } from './draw'
import { resize } from './resize'
import { drag } from './drag'
import { rotate } from './rotate'

export const mouseDownActions = {
  click,
  select,
  draw,
  resize,
  drag,
  rotate,
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseDown/index.js